/*
  Restock inquiry: shows/hides the mailto link in the buy box as the
  visitor switches variants. Hooks into the SAME 'variantChange' event
  theme.js's own Product component uses internally (see theme.js
  ~line 843, dispatched on the product's own .product-section
  container, non-bubbling -- so this listens on that specific
  container, not document, to stay scoped to the right product when
  more than one product form exists on a page, e.g. quick-shop
  modals).
*/
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function buildMailto(email, productTitle, hasVariants, variantTitle) {
    if (!email) { return null; }
    var subject = (hasVariants && variantTitle)
      ? 'Please restock "' + productTitle + '" in size ' + variantTitle
      : 'Please restock "' + productTitle + '"';
    var body = "Hi Eva, I'd buy " + productTitle +
      ((hasVariants && variantTitle) ? ' (' + variantTitle + ')' : '') +
      ' if it came back. — ';
    // encodeURIComponent handles spaces (%20) and non-ASCII (åäö etc)
    // correctly for a mailto: URI -- the recipient address itself is
    // left unencoded, matching normal mailto: convention.
    return 'mailto:' + email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  // variant === undefined: initial page load, read the server-rendered
  // state. variant === an object: a real variant is now selected.
  // variant === null: the current option combination matches no real
  // variant (an "impossible" combo) -- treat as unavailable same as
  // theme.js's own updateCartButton does for this case.
  function refresh(el, variant) {
    var email = el.getAttribute('data-restock-email');
    if (!email) {
      el.hidden = true;
      return;
    }

    var productTitle = el.getAttribute('data-product-title') || '';
    var hasVariants = el.getAttribute('data-has-variants') === 'true';
    var link = el.querySelector('[data-restock-inquiry-link]');
    var available;
    var variantTitle;

    if (variant === undefined) {
      available = el.getAttribute('data-variant-available') === 'true';
      variantTitle = el.getAttribute('data-variant-title') || '';
    } else if (variant) {
      available = !!variant.available;
      variantTitle = variant.title || '';
      el.setAttribute('data-variant-title', variantTitle);
    } else {
      available = false;
      variantTitle = el.getAttribute('data-variant-title') || '';
    }

    var href = buildMailto(email, productTitle, hasVariants, variantTitle);
    if (link && href) { link.href = href; }
    el.hidden = !!available;
  }

  // Idempotent and re-run on eva:pjax:loaded: the restock block and its
  // .product-section container live inside #MainContent, which PJAX
  // swaps wholesale on navigation -- a fresh container needs a fresh
  // listener every time (the old one is gone with the old DOM), and
  // querying fresh each call means this never operates on stale nodes.
  function initRestockInquiry() {
    var blocks = document.querySelectorAll('[data-restock-inquiry]');
    if (!blocks.length) { return; }

    blocks.forEach(function (el) {
      refresh(el);

      var container = el.closest('.product-section');
      if (container) {
        container.addEventListener('variantChange', function (evt) {
          refresh(el, evt.detail.variant);
        });
      }
    });
  }

  ready(initRestockInquiry);
  document.addEventListener('eva:pjax:loaded', initRestockInquiry);
})();
